import { ReactNode } from 'react';
import Item from './Item';
import Question from './Question';
import Answer from './Answer';
import Title from './Title';
import Block from './Block';
import { SchemaStructuredData } from '../atoms/SchemaStructuredData';
import { getStructuredFAQData } from './getStructuredFAQData';

export interface FAQProps {
	testId?: string;
	children: ReactNode;
	className?: string;
	includeStructuredData?: boolean;
}

/**
 * FAQ component that renders a list of frequently asked questions.
 *
 * @example
 * <FAQ>
 *   <FAQ.Title>FAQ</FAQ.Title>
 *   <FAQ.Block>
 *     <FAQ.Item>
 *       <FAQ.Question>What is the meaning of life?</FAQ.Question>
 *       <FAQ.Answer>42</FAQ.Answer>
 *     </FAQ.Item>
 *     <FAQ.Item>
 *       <FAQ.Question>What is the airspeed velocity of an unladen swallow?</FAQ.Question>
 *       <FAQ.Answer>What do you mean? An African or European swallow?</FAQ.Answer>
 *     </FAQ.Item>
 *     <FAQ.Item>
 *       <FAQ.Question>What is your favorite color?</FAQ.Question>
 *       <FAQ.Answer>Yellow, no blue, ahhhhhhhhhhhhhhhrg /is yeeted into the void/</FAQ.Answer>
 *     </FAQ.Item>
 *   </FAQ.Block>
 * </FAQ>
 */
const FAQ = (props: FAQProps) => {
	const {
		testId = 'FAQ',
		children,
		className,
		includeStructuredData = false,
	} = props;

	const structuredData = getStructuredFAQData(children);

	return (
		<div className={className} data-testid={testId}>
			{children}
			{includeStructuredData && <SchemaStructuredData faq={structuredData} />}
		</div>
	);
};

export default FAQ;

FAQ.Title = Title;
FAQ.Item = Item;
FAQ.Question = Question;
FAQ.Answer = Answer;
FAQ.Block = Block;
